import { mapFieldErrorsToSections } from '@vlabs/monokit/shared/lib/errors';
import type { FieldValidationError, SectionRule } from '@vlabs/monokit/shared/lib/errors';

import type { SourceGroupSection } from './types';

const ANALYTICS_PATH_PATTERN = /^analytics\.(\d+)(\.|$)/;

const RULES: SectionRule<SourceGroupSection>[] = [
  { pattern: ANALYTICS_PATH_PATTERN, section: (match) => `va:${Number(match[1])}` },
  { pattern: /^(group_name|description|owner_department|permission_tag)(\.|$)/, section: 'general' },
  { pattern: /^stream_settings(\.|$)/, section: 'stream-settings' },
];

export function mapErrorsToSections(
  errors: FieldValidationError[],
): Partial<Record<SourceGroupSection, boolean>> {
  return mapFieldErrorsToSections(errors, RULES);
}
